import type { IStoreState } from 'interfaces/store/store-state';

export function isDiscardChangesModalOpen(state: IStoreState): boolean {
  return state.views.discardChanges.isOpen;
}
